import React from 'react';
import { BrowserRouter as Router, Switch, Route, Routes } from 'react-router';
import WebPage from './Private/WebPage';
import SarafarazSaifi from './Pages/SarafarazSaifi';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route index element={<WebPage component={SarafarazSaifi} />} />
          <Route path="*" element={<WebPage component={SarafarazSaifi} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
